import angular from 'angular'
import template from './template.html'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaqCalcular', {
    template: template,
    controller: nominasCargacontpaqCalcularComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      data: '<',
      onClose: '&',
    },
  });

function nominasCargacontpaqCalcularComponent($catalogos, $q, $parse, CatalogoImssImpuestos, NominasNominaCalculoConceptos, NominasNominaStatusCalculado) {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;
  $ctrl.aceptar = aceptar;
  $ctrl.agregar = agregar;
  $ctrl.cerrar = cerrar;
  $ctrl.completado = false;
  $ctrl.completados = [];
  $ctrl.errores = [];
  $ctrl.limite = 5;
  $ctrl.listado = [];
  $ctrl.pendientes = [];
  $ctrl.procesando = [];
  $ctrl.progreso = 0;
  $ctrl.pausado = false;
  $ctrl.pausar = pausar;
  $ctrl.reiniciar = reiniciar;

  function $onInit() {
    let promises = [],
      scripts = $ctrl.data.encabezados
        .map(function (item) {
          return function (context, locals) {
            $parse(item.script)(context, locals);

            return context;
          };
        });

    $ctrl.pendientes = $ctrl.data.filas
      .map(function (celdas, indice) {
        let item = {
          indice: indice,
          data: null,
          error: null,
          pendiente: true,
          identificador: celdas[$ctrl.data.identificador],
          parametros: {
            id_proyecto: $ctrl.idProyecto,
            id_nomina: $ctrl.idNomina,
          },
          scripts: [],
        };

        $ctrl.data.encabezados
          .forEach(function (encabezado, i) {
            if (encabezado.indice) {
              item.parametros[encabezado.indice] = celdas[i];
            }

            if (encabezado.id && encabezado.script) {
              item.scripts.push(function (context) {
                return scripts[i](context, {
                  data: celdas[i],
                  utils: {
                    min: Math.min,
                    max: Math.max,
                    round: function (valor, decimales) {
                      return parseFloat(valor.toFixed(decimales || 2));
                    },
                  },
                });
              });
            }
          });

        return item;
      });

    promises.push(NominasNominaCalculoConceptos.get($ctrl.idProyecto, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.conceptos = response.data;

      }));

    promises.push(CatalogoImssImpuestos.get().then((response) => ($ctrl.imssImpuestos = response.data)))

    $q.all(promises)
      .then(function () {
        avanzar();
      });
  }

  function aceptar() {
    if ($ctrl.guardando)
      return;

    $ctrl.guardando = true;

    return NominasNominaStatusCalculado.put($ctrl.idProyecto, $ctrl.idNomina, $ctrl.completados)
      .then(function () {
        cerrar($ctrl.completados);
      }).finally(function () {
        $ctrl.guardando = false;
      });
  }

  function agregar(item, data, error) {
    $ctrl.procesando.splice($ctrl.procesando.indexOf(item), 1);

    item.data = data;
    item.error = error;
    item.pendiente = false;

    if (!error) {
      $ctrl.completados.push(data);
    } else {
      $ctrl.errores.push(item);
    }

    $ctrl.progreso = $ctrl.completados.length / $ctrl.data.filas.length;

    if ($ctrl.pendientes.length) {
      avanzar();
    } else if (!$ctrl.procesando.length) {
      terminar();
    }
  }

  function avanzar() {
    if ($ctrl.pausado || !$ctrl.pendientes.length || $ctrl.procesando.length >= $ctrl.limite)
      return;

    let item = $ctrl.pendientes.shift();

    $ctrl.procesando.push(item);
    $ctrl.listado.push(item);

    avanzar();
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}});
  }

  function pausar() {
    $ctrl.pausado = !$ctrl.pausado;

    avanzar();
  }

  function reiniciar() {
    $ctrl.pendientes = $ctrl.errores
      .map(function (item) {
        item.error = null;
        item.pendiente = true;

        return item;
      });

    $ctrl.listado = $ctrl.listado.filter(function (item) {
      return item.data;
    });

    $ctrl.errores = [];
    $ctrl.pausado = false;

    avanzar();
  }

  function terminar() {
    $ctrl.completado = $ctrl.completados.length === $ctrl.data.filas.length;
    $ctrl.pausado = false;
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/calcular/component.js